/** @format */
import angular from 'angular';
import _ from 'lodash';
import { localeServiceModule } from 'sis-common';
import { approvalStateUtilServiceModule } from './approvalStateUtils.service';

export const commonApprovalStateNameFilter = 'sis-components.approvalStateName';

(function () {
    approvalStateName.$inject = ['$log', 'localeService', 'ApprovalStateUtils'];
    angular
        .module(commonApprovalStateNameFilter, [localeServiceModule, approvalStateUtilServiceModule])
        .filter('approvalStateName', approvalStateName);

    function approvalStateName($log, localeService, ApprovalStateUtils) {
        return function (approvalStateObject) {
            if (approvalStateObject) {
                let localApprovalStateName;
                if (approvalStateObject.approvalState) {
                    // object with approvalState
                    localApprovalStateName = ApprovalStateUtils.resolveName(approvalStateObject.approvalState);
                } else if (approvalStateObject.urn) {
                    // approvalState entity
                    localApprovalStateName = approvalStateObject.name;
                } else if (_.startsWith(approvalStateObject, 'urn')) {
                    // approvalState urn
                    localApprovalStateName = ApprovalStateUtils.resolveName(approvalStateObject);
                } else {
                    $log.info('approvalStateName filter do not know how to handle object: ', approvalStateObject);
                }

                return localeService.getLocalizedValue(localApprovalStateName);
            }
            return undefined;
        };
    }
})();
